//Billboard Router

const DiscoveryBillboard = () => import(/* webpackChunkName: "DiscoveryBillboard" */ '../views/Discovery/Billboard')
const BillboardDetail = () => import(/* webpackChunkNmae: "BillboardDetail"*/ '../views/Discovery/Billboard/Detail')


const billboardRoute = [
    {
      path: '/billboard',
      name: 'discoverybillboard',
      component: DiscoveryBillboard
    },
    {
      path: '/billboard/detail',
      name: 'discoverybillboarddetail',
      component: BillboardDetail
    },
]

export default billboardRoute;
